<template>
  <div>

    <!-- Recommendation Event -->
    <div class="row long_row urgent_notification_msg_row" v-if="latestUrgentNotification">
      <div class="col-12">

        <div class="card ace_sec crd_cal">
          <div class="card-body">

            <div class="ic ic11-alert"></div>

            <div class="row">
              <div class="col-2 row_icon">
                <div class="icon fas fa-user">
                </div>
              </div>

              <div class="col-10 row_detail">

                <div class="row cal_detail">

                  <div class="col-12 block_row">
                    <div class="row_title">
                      {{latestUrgentNotification.message.name}}
                    </div>
                  </div>

                  <div class="col-12 block_row" v-html="latestUrgentNotification.message.text">
                  </div>

                  <div class="col-12 block_row lnk_sec lnk_container" v-if="moreMessages > 1">
                    <span class="lnk_txt">
                      <b-link @click="navigateToChannel">{{moreMessages}} urgent messages</b-link>
                    </span>
                  </div>
                  <div class="col-12 block_row lnk_sec lnk_container" v-else>
                    <span class="lnk_txt">
                      <b-link @click="navigateToChannel">read message</b-link>
                    </span>
                  </div>

                </div>


              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- Recommendation Event -->

  </div>
</template>


<script>
  import { mapState, mapActions } from 'vuex'
  import { db, storage } from '../../../firebase'
  export default {
    name: 'learner-urgent',
    data: () => {
			return {
        urgentMessages: {},
        moreMessages: 0
			}
		},
    mounted () {
      this.loadLearnerUrgent()
    },
    methods: {
			...mapActions([
        'loadNotificationsForStudent'
	    ]),
	    async loadLearnerUrgent () {
        this.urgentMessages = await this.loadNotificationsForStudent()
	    },
      navigateToChannel () {
        return this.$router.push({name: 'channel', params: {uuid: this.userObj.uuid, selectedCurrentChannel: this.latestUrgentNotification.channel, channelType: 'ALL'}})
      }
	  },
    computed: {
      ...mapState({
        'userObj': state => state.login.userObj
      }),
      latestUrgentNotification () {
        if (this.urgentMessages) {
          for (const [key, value] of Object.entries(this.urgentMessages)) {
            let messages = this.urgentMessages[key]
            if (messages.length > 0) {
              this.moreMessages = messages.length
              return {
                'channel': key,
                'message': messages[0]
              }
            }
          }
        }
        return null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerUrgent.vue